// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"144":"9b5f227f","351":"38681417","414":"bdabbaab","573":"d78b7405","701":"27578828","736":"4ee0db63"}[chunkId] + ".chunk.css";
};